import React, { Component, Fragment } from 'react';
import { AvGroup, AvField } from 'availity-reactstrap-validation';
import i18n from '../../../../../i18next';

class TaxFields extends Component {
    renderTaxBandsOptions() {
        if (this.props.taxBands !== undefined && this.props.taxBands !== null && this.props.taxBands.length > 0) {

            return this.props.taxBands.map((tax, i) => {
                return (
                    <option key={`taxBand${i}`} data-posId={tax.posId} id={tax.id} data-value={tax.taxPercent} data-taxName={tax.taxName} value={tax.id}>{tax.taxName ? `${tax.taxName} - ` : null} {tax.taxPercent} %</option>
                );
            });
        }
    }

    render() {
        return (
            <Fragment>
                <AvGroup>
                    <AvField type="select" name="taxBand" id="taxBand" label={i18n.t('screens:productScreen.taxBands')}
                        onChange={this.props.changeState}
                        value={`${this.props.taxBandId}`}
                        required={this.props.supportCsvFiles}
                        disabled={this.props.supportCsvFiles ? false : true}
                    >
                        {this.props.supportCsvFiles ? null : <option id='disabledTaxBand' value=''>{`${this.props.taxPercent} %`}</option>}
                        {!this.props.supportCsvFiles ? null : <option id='selectTaxBand' value=''>{i18n.t('screens:productScreen.selectTax')}</option>}
                        {!this.props.supportCsvFiles ? null : this.renderTaxBandsOptions()}
                    </AvField>
                </AvGroup>
                {
                    this.props.showSecondaryTax &&
                    <AvGroup>
                        <AvField type='select' name='secondaryTaxBand' id='secondaryTaxBand' label='Secondary Tax Band'
                            onChange={this.props.changeState}
                            value={this.props.secondaryTaxBandId}>
                            <option value=''>{i18n.t('screens:productScreen.selectTax')}</option>
                            {this.renderTaxBandsOptions()}
                        </AvField>
                    </AvGroup>
                }
            </Fragment>
        )
    }
}

export default TaxFields;


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/additionalInformation/TaxFields.js